import React, { useState } from "react";
import styled from "styled-components";
import SelectModal from "./SelectModal";
import { useEffect } from "react";
import moment from "moment";

import ArrowDown from "@material-ui/icons/ArrowDropDown";
import ArrowRight from "@material-ui/icons/ArrowRight";
import Loader from "../Loader";

function LogsModalMetada({ show, onRetrieveLogs }) {
  console.log("changing");

  const noCharacter = 100;

  const [openeds, setOpeneds] = useState([]);
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleRetrieveLogs = async () => {
    setLoading(true);
    const logs = await onRetrieveLogs();
    setLogs(logs);
    setLoading(false);
  };

  useEffect(() => {
    handleRetrieveLogs();
  }, []);

  return (
    <Overlay>
      <Content>
        {loading ? (
          <Loader />
        ) : logs.length === 0 ? (
          <NoEvents>SEM DADOS</NoEvents>
        ) : (
          <Scroll>
            <Table>
              <TitleRow>
                <TimeTitle>Data</TimeTitle>
                <EventTitle>Evento</EventTitle>
              </TitleRow>
              {logs.map(({ timestamp, message }, index) => (
                <ResultRow key={index}>
                  <TimeResult>
                    {moment(timestamp).format("DD/MM/YYYY HH:mm")}
                  </TimeResult>
                  <MessageResult>
                    {openeds.includes(index) ? (
                      <Message
                        onClick={() => {
                          const newOpeneds = openeds.filter(
                            (opened) => opened !== index,
                          );
                          setOpeneds(newOpeneds);
                        }}
                      >
                        <ArrowDown />
                        <span>{message}</span>
                      </Message>
                    ) : message.length > noCharacter ? (
                      <Message
                        onClick={() => {
                          const newOpeneds = [...openeds, index];
                          setOpeneds(newOpeneds);
                        }}
                      >
                        <ArrowRight />
                        <span>{message.slice(0, noCharacter)}</span>
                      </Message>
                    ) : (
                      <SortMessage>{message}</SortMessage>
                    )}
                  </MessageResult>
                </ResultRow>
              ))}
            </Table>
          </Scroll>
        )}

        <Buttons>
          <SaveButton
            onClick={(e) => {
              e.preventDefault();
              handleRetrieveLogs();
            }}
          >
            Recarregar logs
          </SaveButton>
          <SaveButton
            close
            onClick={(e) => {
              e.preventDefault();
              show(false);
            }}
          >
            Fechar
          </SaveButton>
        </Buttons>
      </Content>
    </Overlay>
  );
}

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 90%;
`;

const SaveButton = styled.button`
  background-color: #00a8ff;
  color: #fff;
  border: none;
  border-radius: 5px;
  margin-left: 4px;
  margin-right: 4px;
  width: ${(props) => (props.close ? "40%" : "60%")};
  padding: 10px;
  margin-top: 10px;
  &:hover {
    background-color: #0091ea;
  }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

const Content = styled.div`
  background-color: white;
  padding: 20px;
  margin: 10px;
  border: 1px solid #ddd;
  border-radius: 10px;
  overflow-y: scroll;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80%;
`;

const NoEvents = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 1.5rem;
  font-weight: bold;
  color: #999;
`;

const Scroll = styled.div`
  overflow-y: scroll;
  height: calc(100vh - 100px);
`;

const SortMessage = styled.span`
  margin-left: 25px;
`;

const Message = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  word-break: break-all;
`;

const MessageResult = styled.td`
  display: flex;
  align-items: center;
  padding: 5px;
`;

const TimeResult = styled.td`
  width: 20%;
  padding: 5px;
  text-align: center;
`;

const EventTitle = styled.th`
  width: 50%;
  text-align: center;
`;

const TitleRow = styled.tr`
  background-color: #f5f5f5;
`;

const ResultRow = styled.tr`
  justify-content: center;
  align-items: center;
  border: 2px solid #f5f5f5;
`;

const TimeTitle = styled.th`
  width: 30%;
  margin-bottom: 20px;
`;

const Table = styled.table`
  width: 99%;
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
  margin-bottom: 20px;
`;
export default React.memo(LogsModalMetada);
